import raphvee from "../assets/images/folio-bg/1.jpg";
import myglamsy from "../assets/images/folio-bg/2.jpg";
import terence from "../assets/images/folio-bg/3.jpg";
import creartfrique from "../assets/images/folio-bg/4.jpg";
import simplyprepaidactivations from "../assets/images/folio-bg/5.jpg";
import royalplace from "../assets/images/folio-bg/6.jpg";
import ifindrental from "../assets/images/folio-bg/7.jpg";
import mylewa from "../assets/images/folio-bg/8.jpg";
import todolist from "../assets/images/folio-bg/0.jpg";
import trypto from "../assets/images/folio-bg/9.jpg";

const allImages = [
  raphvee.toString(),
  myglamsy.toString(),
  terence.toString(),
  creartfrique.toString(),
  simplyprepaidactivations.toString(),
  royalplace.toString(),
  ifindrental.toString(),
  mylewa.toString(),
  todolist.toString(),
  trypto.toString(),
];


const getRandomImage = () => allImages[Math.floor(Math.random() * allImages.length)];

export default getRandomImage;
